import ProjectBasedLearningView from "@features/tools/view/project-based-learning-view";

const ProjectBasedLearning = () => {
  return <ProjectBasedLearningView />;
};

export default ProjectBasedLearning;
